/**
 * Инициализация дополнительных блоков на странице
 */
export function initAdditionalSections() {
  // Обработка бизнес-табов
  const businessTabs = document.querySelectorAll('.business__tab');

  if (businessTabs.length) {
    businessTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Убираем активный класс со всех табов
        businessTabs.forEach(t => t.classList.remove('business__tab--active'));

        // Добавляем активный класс текущему табу
        tab.classList.add('business__tab--active');

        // Скрываем все панели
        const panels = document.querySelectorAll('.business__panel');
        panels.forEach(panel => panel.classList.remove('business__panel--active'));

        // Показываем нужную панель
        const targetPanel = document.getElementById(tab.dataset.target);
        if (targetPanel) {
          targetPanel.classList.add('business__panel--active');
        }
      });
    });
  }

  // Обработка корпоративных-табов
  const corporateTabs = document.querySelectorAll('.corporate__tab');

  if (corporateTabs.length) {
    corporateTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Убираем активный класс со всех табов
        corporateTabs.forEach(t => t.classList.remove('corporate__tab--active'));

        // Добавляем активный класс текущему табу
        tab.classList.add('corporate__tab--active');

        // Скрываем все панели
        const panels = document.querySelectorAll('.corporate__panel');
        panels.forEach(panel => panel.classList.remove('corporate__panel--active'));

        // Показываем нужную панель
        const targetPanel = document.getElementById(tab.dataset.target);
        if (targetPanel) {
          targetPanel.classList.add('corporate__panel--active');
        }
      });
    });
  }

  // Инициализация стрелок слайдера для блока мероприятий
  const eventsSlider = document.querySelector('.events__slider');
  const prevArrow = document.querySelector('.events__arrow--prev');
  const nextArrow = document.querySelector('.events__arrow--next');

  if (eventsSlider && prevArrow && nextArrow) {
    // Обработчик для кнопки "назад"
    prevArrow.addEventListener('click', () => {
      eventsSlider.scrollBy({
        left: -370,
        behavior: 'smooth'
      });
    });

    // Обработчик для кнопки "вперед"
    nextArrow.addEventListener('click', () => {
      eventsSlider.scrollBy({
        left: 370,
        behavior: 'smooth'
      });
    });
  }

  // // Обработка FAQ-блока
  // const faqItems = document.querySelectorAll('.faq__item');

  // if (faqItems.length) {
  //   faqItems.forEach(item => {
  //     const question = item.querySelector('.faq__question');

  //     if (question) {
  //       question.addEventListener('click', () => {

  //         // faqItems.forEach(faqItem => {
  //         //   faqItem.classList.remove('active');
  //         // });
          
  //         item.classList.add('active');
  //         // // Если элемент уже активен, то закрываем его
  //         // if (item.classList.contains('active')) {
  //         // } else {
  //         //   // Закрываем все открытые вопросы
           

  //         //   // Открываем текущий вопрос
  //         // }
  //       });
  //     }
  //   });

  //   // По умолчанию открываем первый вопрос
  //   if (faqItems[0]) {
  //     faqItems[0].classList.add('active');
  //   }
  // }

  // Добавляем анимацию при прокрутке для секций
  const animateSections = () => {
    const sections = document.querySelectorAll('section');

    sections.forEach(section => {
      // Проверяем, видна ли секция в области видимости
      const sectionTop = section.getBoundingClientRect().top;
      const sectionVisible = sectionTop < window.innerHeight - 100;

      if (sectionVisible && !section.classList.contains('fade-in')) {
        section.classList.add('fade-in');

        // Анимируем элементы внутри секции
        const children = section.querySelectorAll('.advantages__item, .course-card, .methodology__step, .stats__item, .why-us__item, .process__step, .faq__item, .summer-card, .exam-card, .partners__item');

        children.forEach((child, index) => {
          setTimeout(() => {
            child.classList.add('slide-up');
          }, 100 * index);
        });
      }
    });
  };

  // Запускаем анимацию при загрузке и при прокрутке
  animateSections();
  window.addEventListener('scroll', animateSections);

  // Анимация счетчиков в блоке результатов
  const animateCounters = () => {
    const counters = document.querySelectorAll('.results__number');

    if (counters.length) {
      counters.forEach(counter => {
        // Проверяем, был ли счетчик уже анимирован
        if (counter.classList.contains('animated')) {
          return;
        }

        const target = parseInt(counter.dataset.target || counter.innerText.replace(/\D/g, ''), 10);
        let count = 0;
        const duration = 2000; // Продолжительность анимации в мс
        const step = target / (duration / 30); // Шаг анимации

        // Запускаем анимацию только если счетчик виден на экране
        const counterTop = counter.getBoundingClientRect().top;
        if (counterTop < window.innerHeight - 100) {
          counter.classList.add('animated');

          const updateCount = () => {
            if (count < target) {
              count = Math.min(count + step, target);

              // Если счетчик содержит знак +, добавляем его
              if (counter.innerText.includes('+')) {
                counter.innerText = Math.floor(count) + '+';
              } else if (counter.innerText.includes('%')) {
                counter.innerText = Math.floor(count) + '%';
              } else {
                counter.innerText = Math.floor(count);
              }

              // Продолжаем анимацию
              requestAnimationFrame(updateCount);
            }
          };

          updateCount();
        }
      });
    }
  };

  // Запускаем анимацию счетчиков при прокрутке
  window.addEventListener('scroll', animateCounters);
  // Запускаем анимацию при загрузке страницы
  animateCounters();
}
